export default __webpack_public_path__ + "static/media/changemakers.463e7e28.jpg";